import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const AreaMaster = React.lazy(() => import('.'));

export const areaMasterRoutes = [
  new Route({
    path: 'area-master',
    element: AreaMaster,
    children: [],
  }),
];
